import React from "react";
import { Text, Stack, Switcher, Box, WireSmallIcon } from "@thecb/components";
import { SEMI_BOLD } from "@/constants/fonts";
import DisplayValue from "@/components/generic/DisplayValue";

const WirePaymentDetails = ({ wirePayment }) => {
  const unavailableMessage = "Not available";
  const name = wirePayment?.name?.value ?? unavailableMessage;
  const description = wirePayment?.description?.value ?? unavailableMessage;
  const effectiveDate = wirePayment?.effectiveDate?.value ?? unavailableMessage;

  return (
    <Stack childGap="0.5rem">
      <Switcher
        breakpoint="700px"
        childGap="0.25rem"
        largeChild={2}
        largeChildSize={5}
      >
        <Text variant="pS" weight={SEMI_BOLD} extraStyles="flex-basis: 17rem;">
          Payment method
        </Text>
        <Box padding="0" extraStyles="display: flex; align-items: center;">
          <WireSmallIcon />
          <Text variant="pS" extraStyles="padding-left: 0.5rem;">
            Wire transfer
          </Text>
        </Box>
      </Switcher>
      <DisplayValue title="Effective date" value={effectiveDate} />
      <DisplayValue title="Name" value={name} />
      <DisplayValue title="Description" value={description} />
    </Stack>
  );
};

export default WirePaymentDetails;
